import Documents, { IDocument, IDocumentApiModel } from './Document.model';

export interface IProductDocuments {
  id: number;
  documentId: string;
  document: IDocument;
}

export interface IProductDocumentsApiModel {
  id: number;
  documentId: string;
  document: IDocumentApiModel;
}

export default class ProductDocuments implements IProductDocuments {
  public readonly id: number;

  public readonly documentId: string;

  public readonly document: IDocument;

  constructor(id: number, documentId: string, document: IDocument) {
    this.id = id;
    this.documentId = documentId;
    this.document = document;
  }

  static fromApiModel(apiModel: IProductDocumentsApiModel) {
    const { id, documentId } = apiModel;

    const document = Documents.fromApiModel(apiModel.document);
    return new ProductDocuments(id, documentId, document);
  }

  static arrayFromApiModel(arrayApiModel: IProductDocumentsApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, documentId } = apiModel;

      const document = Documents.fromApiModel(apiModel.document);

      return new ProductDocuments(id, documentId, document);
    });

    return array;
  }
}
